<script setup lang="ts">
import { computed } from 'vue'

const cart = useCartStore()
const modals = useModalsStore()

const quantity = ref(0)

const loading = ref(false)

const price = computed(() => {
  if (!modals.addToCart) return 0

  return quantity.value * modals.addToCart.price
})
</script>

<template>
  <AppContainer>
    <div class="row justify-end">
      <div class="col-lg-6">
        <div class="app-modal-add-to-cart__content">
          <div class="mb-3 flex items-center justify-between">
            <div>
              <h4>
                {{ quantity }} x {{ $t('string.tickets') }}:
                {{ formatCurrency(price) }}
              </h4>
              <p class="text-secondary-nav">{{ modals.addToCart?.title }}</p>
            </div>

            <AppInputQuantity
              v-model="quantity"
              :min="modals.addToCart?.minQuantity"
              :max="modals.addToCart?.maxQuantity"
            />
          </div>

          <AppButton
            v-if="modals.addToCart"
            full-width
            :loading="loading"
            @click="
              async () => {
                if (!modals.addToCart) return

                loading = true

                await cart.addToCart({
                  productId: modals.addToCart.productId,
                  ticketCategoryId: modals.addToCart.ticketCategoryId,
                  variations: [{ quantity }],
                })

                loading = false
              }
            "
          >
            {{ $t('modal.add-to-cart.button') }}
          </AppButton>
        </div>
      </div>

      <div class="col-lg-1"></div>
    </div>
  </AppContainer>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';
</style>
